export default "__VITE_ASSET__D7opqcE5__"